import ModalImage from 'components/ModalImage';
/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';

/**
 * Modal com a identidade visual do projeto.
 *
 * @param imageUrl {string} caminho da imagem
 * @param callback {function} Função callback
 */
/**
 * ReactDOM.render() função recebe dois argumentos, codigo HTML e um 
 * elemento html, a função tem como objetivo exibir o codigo HTML espe-
 * cificado dentro do elemento HTML especificado.
 */
export default ({ imageUrl, callback  }) => {
  ReactDOM.render(
    <ModalImage         
      callback={callback}      
      imageUrl={imageUrl}
    />,
    document.getElementById('alert')
  );
};